import {Input, Switch, Textarea, Typography} from "@material-tailwind/react";
import Dict from "../../../helper/dict";
import React, {useContext, useEffect, useState} from "react";
import "../../../style/datePicker.css"
import FileInput from "../../system/fileInput";
import {AgentRequestContext} from "../../../context/agent_context";

export function AgentDisplayDetails() {

  const {agentDisplayDetails, setAgentDisplayDetails} = useContext(AgentRequestContext)


  const [installment, setInstallment] = useState(false);

  return (
    <>
      <div className="grid grid-cols-1 gap-4 p-4 overflow-y-scroll md:grid-cols-2 xxl:grid-cols-3">

        <div className="w-full mt-2 mb-4">
          <Input variant="standard"
                 value={agentDisplayDetails?.rate ?? 1}
                 label={Dict('rate')}
                 placeholder={Dict('rate')}
                 type="number"
                 min="1"
                 step="0.1"
                 onChange={(e) => {
                   setAgentDisplayDetails(agentDisplayDetails => ({
                     ...agentDisplayDetails,
                     rate: e.target.value,
                   }))
                 }}
          />
        </div>

        <div className="w-full mt-2 mb-4">
          <Input variant="standard"
                 value={agentDisplayDetails?.views ?? 1}
                 label={Dict('views')}
                 placeholder={Dict('views')}
                 type="number"
                 min="1"
                 step="10"
                 onChange={(e) => {
                   setAgentDisplayDetails(agentDisplayDetails => ({
                     ...agentDisplayDetails,
                     views: e.target.value,
                   }))
                 }}
          />
        </div>

        <div className="flex flex-row w-full mt-2 mb-4">
          <Switch
            label={
              <Typography color="blue-gray" className="font-medium">
                قسطی فعال / غیرفعال
              </Typography>
            }
            checked={installment}
            onChange={(e) => {
              setInstallment(e.target.checked)
            }}
            labelProps={{className: "mx-4"}}
          />
        </div>

        <div className="flex flex-row mb-4 md:w-1/2">
          <FileInput
            label={Dict('visit_card')}
            fileCode={agentDisplayDetails?.visit_card}
            onChange={(e) => {
              setAgentDisplayDetails(agentDisplayDetails => ({
                ...agentDisplayDetails,
                visit_card: e.target.files[0],
              }))
            }}/>
        </div>

        <div className="flex flex-row w-full mb-4 md:col-span-2">
          <Textarea
            variant="standard"
            value={agentDisplayDetails?.clip}
            label={Dict('introduction_file')}
            onChange={(e) => {
              setAgentDisplayDetails(agentDisplayDetails => ({
                ...agentDisplayDetails,
                clip: e.target.value,
              }))
            }}
          />
        </div>

        <div className="flex flex-row w-full mb-4 md:col-span-2">
          <Textarea
            variant="standard"
            value={agentDisplayDetails?.education_clip_1}
            label={'ویدیو آموزشی 1'}
            onChange={(e) => {
              setAgentDisplayDetails(agentDisplayDetails => ({
                ...agentDisplayDetails,
                education_clip_1: e.target.value,
              }))
            }}
          />
        </div>

        <div className="flex flex-row w-full mb-4 md:col-span-2">
          <Textarea
            variant="standard"
            value={agentDisplayDetails?.education_clip_2}
            label={'ویدیو آموزشی 2'}
            onChange={(e) => {
              setAgentDisplayDetails(agentDisplayDetails => ({
                ...agentDisplayDetails,
                education_clip_2: e.target.value,
              }))
            }}
          />
        </div>

      </div>
    </>
  );
}
